import { useTranslation } from 'react-i18next';

import Button from '../../../../../../components/buttons/Button';
import type { BingoResultToShowType } from '../../../../../../stores/bingo/types';
import { useBingoWidgetCallbacks } from '../../../../hooks';
import { BingoWidgetLogo } from '../../BingoWidgetLogo/BingoWidgetLogo';
import { BingoWideWidgetWrapper } from '../BingoWideWidgetWrapper/BingoWideWidgetWrapper';

import styles from './BingoRewardWideWidget.module.scss';

interface BingoRewardWideWidgetProps {
  event: BingoResultToShowType;
}

export function BingoRewardWideWidget(props: BingoRewardWideWidgetProps) {
  const { event } = props;
  const { t } = useTranslation();
  const { onResultClick } = useBingoWidgetCallbacks();
  const bingoType = event?.coinType === 'GC' ? 'CASUAL' : 'SWEEP';
  const feature = event.isFreeDaubEvent ? 'daub' : 'general';

  return (
    <BingoWideWidgetWrapper feature={feature} wrapperClassName={styles.wrapper} onClick={() => onResultClick(event)}>
      <BingoWidgetLogo bingoType={bingoType} sizeType="wide" />
      <div className={styles.content}>
        <div className={styles.topWrapper}>
          <span className={styles.text}>
            <span className={bingoType === 'SWEEP' ? styles.textSweep : styles.textCasual}>
              {t('prime.bingo.bingo')}
            </span>{' '}
            {t('prime.latestBingoResult.youWonSmall')}
          </span>
        </div>
        <div className={styles.btnWrapper}>
          <Button btnType="purple-blue" className={styles.btn}>
            {t('prime.latestBingoResult.seePrize')}
          </Button>
        </div>
      </div>
    </BingoWideWidgetWrapper>
  );
}
